import { render } from "./EyeComponent.vue?vue&type=template&id=5cbd6cde&scoped=true"
import script from "./EyeComponent.vue?vue&type=script&lang=js"
export * from "./EyeComponent.vue?vue&type=script&lang=js"

import "./EyeComponent.vue?vue&type=style&index=0&id=5cbd6cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbd6cde"]])

export default __exports__